import { Injectable } from '@angular/core';

import { ConfigService } from '@core/config/config.service';
import { AuthService } from '@core/services/auth.service';
import { IAsyncTaskReport, ITask } from './async-task-constants';

@Injectable({
  providedIn: 'root'
})
export class ExternalEquipmentOrderSyncReport implements IAsyncTaskReport {

  constructor(private readonly authService: AuthService, private readonly config: ConfigService) {
  }

  public generate(task: ITask): string {
    if (task.status === 'success') {
      const createdReferences: string[] = task.detail['created_references'] || [];
      const creationErrors: string[] = task.detail['creation_errors'] || [];

      let createdReferenceList: string = '';
      if (createdReferences.length) {
        createdReferenceList = `<ul><li>${createdReferences.join('</li><li>')}</li></ul>`;
      }

      let creationErrorList: string = '';
      if (creationErrors.length) {
        creationErrorList = `<ul><li>${creationErrors.join('</li><li>')}</li></ul>`;
      }

      return `
        <div>Synchronisation des commandes fournisseur effectuée avec succès.</div><br>
        <div>Commandes fournisseur récupérées : ${createdReferences.length}</div>
        ${createdReferenceList}
        <br>
        <div>Commandes fournisseur non récupérées : ${creationErrors.length}</div>
        ${creationErrorList}
      `;

    } else {
      return `<div>Une erreur est survenue lors de la récupération des commandes fournisseur.</div><br>`;
    }
  }
}
